// @flow
import React from 'react';
import Spinner from '@atlaskit/spinner';

import * as S from './styled';

type Props = {
  /**
   * Spinner size.
   * */
  size: string,
};

const InitialLoader = ({ size }: Props) => (
  <S.InitialLoader>
    <Spinner size={size} />
  </S.InitialLoader>
);

export default InitialLoader;
